import { CSSObject } from "@emotion/react";
import { typographyStyles, constants } from "@newsela/angelou";

const { ui } = constants.colors;
const circular = typographyStyles.fontFamily.circular;

export const errorPanelCss: CSSObject = {
  margin: "auto",
  marginTop: "1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  maxWidth: "60%",
};

export const errorTitleCss = [
  typographyStyles.heading3Obj,
  {
    ...circular,
    color: ui.neutral[700],
    lineHeight: "2rem",
  },
];

export const errorBodyCss = [
  typographyStyles.textMObj,
  {
    color: ui.neutral[600],
  },
];
